<template>
  <div class="game-setting">
    <v-row class="mx-auto">
      <v-col class="mx-auto mb-n4">
        <td style="width:140px;">
          <p style="white-space: nowrap"><b>陰謀カード：</b></p>
        </td>
        <td style="width:140px">
          <!-- <v-select
            class="selecter"
            :items="plotGame"
            v-model=selectedPlot
            dense
            solo
          ></v-select> -->
          <b>{{selectedPlot}}</b>
        </td>

      </v-col>

      <v-col class="mx-auto mb-n4">
        <td style="width:150px">
          <p style="white-space: nowrap"><b>スパイの人数：</b></p>
        </td>
        <td style="width:120px">

          <!-- <v-select
            class="selecter"
            :items="[spyNum]"
            v-model=selectedSpyNum
            dense
            solo
          ></v-select> -->
          <p v-if="selectedSpyNum>1"><b>{{selectedSpyNum}}</b></p>
          <p v-else><b>-</b></p>
        </td>

      </v-col>
    </v-row>
    <div class="plot-table" style="">
      <v-expand-transition>
        <v-card
          v-show="selectedPlot=='あり'"
          elevation=0
          class="background-color"
        >
          <div class="plot-table">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr v-for="n of 5" v-bind:key="n">
                    <td style="background-color:#FFF">
                      <span v-on:click="showEffect(plots[n*2-2].id)" class="plot-name"><u><b>{{ plots[n*2-2].name }}</b></u></span>
                    </td>
                    <td style="background-color:#FFF">
                      {{ numOfPlots[n*2-2] }}
                    </td>
                    <td v-if="n<5" style="background-color:#FFF">
                      <span v-on:click="showEffect(plots[n*2-1].id)" class="plot-name"><u><b>{{ plots[n*2-1].name }}</b></u></span>
                    </td>
                    <td v-else style="background-color:#222288;color:#FFF">
                      <b>合計</b>
                    </td>
                    <td v-if="n<5" style="background-color:#FFF">
                      {{ numOfPlots[n*2-1] }}
                    </td>
                    <td v-else style="background-color:#222288;color:#FFF">
                      <b>{{ sumPlots }}</b>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-expand-transition>
    </div>
  </div>
</template>
<script>
export default {
  data (){
    return {
      plotGame: ['あり'],
      selectedPlot: 'あり',
    }
  },
  computed: {
    users : function() {
      return this.$store.state.userList.users
    },
    plots () {
      return this.$store.state.plotData.plotName
    },
    spyNum() {
      var number = 1
      if (this.users.length > 9){
        number = 4
      }else if (this.users.length > 6){
        number = 3
      }else if (this.users.length > 4){
        number = 2
      }
      return number
    },
    selectedSpyNum () {
      return this.spyNum
    },
    numOfPlots() {
      var arr = [2,2,1,1,1,0,0,0,0]
      if (this.users.length > 6){
        arr = [2,2,2,3,1,2,1,1,1]
      }
      return arr
    },
    sumPlots (){
      return this.numOfPlots.reduce(function(prev, current) {
        return prev+current;
      });
    }
  },
  methods: {
    showEffect(id) {
      this.$emit('show-effect', id)
    }
  }
}
</script>
<style>
#game-setting td {
  font-size: 16px;
  background-color:#F6F6FA;
  text-align: center;
}

</style>
